export enum AnalyticsEvent {
	hermes_join_congress = 'hermes_join_congress',
	hermes_join_event = 'hermes_join_event',
	hermes_join_channel = 'hermes_join_channel',
}
